import { render, staticRenderFns } from "./WebBanner.vue?vue&type=template&id=4c511797&scoped=true"
import script from "./WebBanner.vue?vue&type=script&lang=js"
export * from "./WebBanner.vue?vue&type=script&lang=js"
import style0 from "./WebBanner.vue?vue&type=style&index=0&id=4c511797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c511797",
  null
  
)

export default component.exports